import { get } from 'svelte/store';
import { apiUrl } from './constants';
import { account as accountStore } from './stores';
function getAuthorization() {
    const account = get(accountStore);
    // noinspection JSDeprecatedSymbols
    return 'Basic ' + btoa(account.name + ":" + account.password);
}
export async function authorize(name, password) {
    const response = await fetch(`${apiUrl}/authorize`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            name, password
        })
    });
    return await response.json();
}
export async function getDeviceConnections(id) {
    const response = await fetch(`${apiUrl}/devices/${id}/connections`, {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function getDeviceConnectionHistory(id, params) {
    const response = await fetch(`${apiUrl}/devices/${id}/connectionHistory?` + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function getLoginEvents(params) {
    const response = await fetch(`${apiUrl}/loginEvents?` + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function postDevices(body) {
    const response = await fetch(`${apiUrl}/devices`, {
        method: 'POST',
        headers: {
            'Authorization': getAuthorization(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    });
    return await response.json();
}
export async function patchDevice(id, body) {
    const response = await fetch(`${apiUrl}/devices/${id}`, {
        method: 'PATCH',
        headers: {
            'Authorization': getAuthorization(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    });
    return await response.json();
}
export async function deleteDevice(id) {
    const response = await fetch(`${apiUrl}/devices/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': getAuthorization(),
            'Content-Type': 'application/json',
        }
    });
    return await response.json();
}
export async function getDevices(params) {
    const response = await fetch(`${apiUrl}/devices?` + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function postDeviceAction(id, action) {
    const response = await fetch(`${apiUrl}/devices/${id}/action`, {
        method: 'POST',
        headers: {
            'Authorization': getAuthorization(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            action
        })
    });
    return await response.json();
}
export async function getDeviceLogs(id, params) {
    const response = await fetch(`${apiUrl}/devices/${id}/logs?` + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function getDeviceUniqueLogs(id, params) {
    const response = await fetch(`${apiUrl}/devices/${id}/uniqueLogs?` + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function postDeviceSpeedtest(id) {
    const response = await fetch(`${apiUrl}/devices/${id}/speedtest`, {
        method: 'POST',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export async function postDeviceAccessKey(id) {
    const response = await fetch(`${apiUrl}/devices/${id}/accessKey`, {
        method: 'POST',
        headers: {
            'Authorization': getAuthorization()
        }
    });
    return await response.json();
}
export const api = {
    authorize, getDevices, patchDevice, deleteDevice, postDevices, postDeviceAction,
    getDeviceLogs, getDeviceUniqueLogs, postDeviceSpeedtest, postDeviceAccessKey,
    getDeviceConnections, getDeviceConnectionHistory
};
